require('./es6.array.iterator');

var global = require('./$.global'),
    hide = require('./$.hide'),
    Iterators = require('./$.iterators'),
    ITERATOR = require('./$.wks')('iterator'),
    NL = global.NodeList,
    HTC = global.HTMLCollection,
    NLProto = NL && NL.prototype,
    HTCProto = HTC && HTC.prototype,
    ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

if (NLProto && !NLProto[ITERATOR]) hide(NLProto, ITERATOR, ArrayValues);
if (HTCProto && !HTCProto[ITERATOR]) hide(HTCProto, ITERATOR, ArrayValues);